// ScrollLogoText.js
import React from "react";
import Marquee from "react-fast-marquee";
import logo from '../assets/rem-logo.png'; 

const ScrollLogoText = () => {
  return (
    <div className="bg-purple-700 py-2 border-t-4 border-b-4 border-white ">
      <Marquee speed={90} gradient={false}>
        <div className="flex items-center ml-5">
          <img src={logo} alt="Invoicify Logo" className="h-12 mr-3" />
          <p className="text-white text-xl font-sans">
            <span className="text-white font-bold">Powergenic Engineering</span> - Distillation Column Internal
          </p>
        </div>
        <div className="flex items-center ml-5">
          <img src={logo} alt="Invoicify Logo" className="h-12 mr-3" />
          <p className="text-white text-xl font-sans">
          <span className="text-white font-bold">Powergenic Engineering</span> - Distillation Column Maintenance
          </p>
        </div>
        <div className="flex items-center ml-5">
          <img src={logo} alt="Invoicify Logo" className="h-12 mr-3" />
          <p className="text-white text-xl font-sans">
            <span className="text-white font-bold">Powergenic Engineering</span> - Distillation Column Supervision
          </p>
        </div>
        <div className="flex items-center ml-5">
          <img src={logo} alt="Invoicify Logo" className="h-12 mr-3" />
          <p className="text-white text-xl font-sans">
            <span className="text-white font-bold">Powergenic Engineering</span> - Maintenance of Distillation Column
        
          </p>
        </div>
      </Marquee>
    </div>
  );
};

export default ScrollLogoText;